import { render, staticRenderFns } from "./CustomerActionCell.vue?vue&type=template&id=2370bf45&scoped=true&"
import script from "./CustomerActionCell.vue?vue&type=script&lang=js&"
export * from "./CustomerActionCell.vue?vue&type=script&lang=js&"
import style0 from "./CustomerActionCell.vue?vue&type=style&index=0&id=2370bf45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370bf45",
  null
  
)

export default component.exports